import { render, staticRenderFns } from "./StatsPayments.vue?vue&type=template&id=300dd68c"
import script from "./StatsPayments.vue?vue&type=script&lang=js"
export * from "./StatsPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports